export default __webpack_public_path__ + "static/media/benefits-title-icon.b7a3c1fa.svg";